import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '../pages/LoginPage.vue';
import HomeSelectPage from '../pages/HomeSelectPage.vue';
import SearchPage from '../pages/SearchPage.vue';
import PlanningPage from '../pages/PlanningPage.vue';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/login', name: 'Login', component: LoginPage },
    { path: '/', name: 'Home', component: HomeSelectPage },
    { path: '/search', name: 'Search', component: SearchPage },
    { path: '/planning', name: 'Planning', component: PlanningPage },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
});

export default router;
